import { render, staticRenderFns } from "./UpdateContactPersonNameForm.vue?vue&type=template&id=0328a246"
import script from "./UpdateContactPersonNameForm.vue?vue&type=script&lang=ts"
export * from "./UpdateContactPersonNameForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports